var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("inner-page-title", { attrs: { title: "City Center Shuttle" } }),
      _c("div", { staticClass: "map-container" }, [
        _c("div", { ref: "google_map", staticStyle: { height: "400px" } })
      ]),
      _c(
        "div",
        { staticClass: "container route-information" },
        [
          _c(
            "div",
            { staticClass: "direction-picker-container" },
            [
              _c(
                "el-select",
                {
                  staticStyle: {
                    width: "200px",
                    "margin-right": "5px",
                    flex: "1"
                  },
                  attrs: { placeholder: "Direction" },
                  model: {
                    value: _vm.direction,
                    callback: function($$v) {
                      _vm.direction = $$v
                    },
                    expression: "direction"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "To the office", value: "go" }
                  }),
                  _c("el-option", { attrs: { label: "Home", value: "back" } })
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "secondary" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/shuttle-live-info/sddfdsfdsf")
                    }
                  }
                },
                [_vm._v("View realtime")]
              )
            ],
            1
          ),
          _c("h4", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("Timetable")
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.timetableData,
                border: "",
                "highlight-current-row": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "stop_name", label: "Stop", "min-width": "180" }
              }),
              _c("el-table-column", {
                attrs: { prop: "time_one", label: "07:00", width: "70" }
              }),
              _c("el-table-column", {
                attrs: { prop: "time_two", label: "08:00", width: "70" }
              }),
              _c("el-table-column", {
                attrs: { prop: "time_three", label: "08:15", width: "70" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "button",
        {
          staticClass: "floating-button",
          on: {
            click: function($event) {
              _vm.modal_active = true
            }
          }
        },
        [_vm._v("Book")]
      ),
      _c(
        "modal",
        {
          attrs: { title: "Book shuttle" },
          model: {
            value: _vm.modal_active,
            callback: function($$v) {
              _vm.modal_active = $$v
            },
            expression: "modal_active"
          }
        },
        [
          _c("mobility-booking", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading_modal,
                expression: "loading_modal"
              }
            ],
            on: { onBook: _vm.onBook }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }